// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z2pru","left":"styles_left__8jhuS"};